import React from 'react';
import { AwardIcon } from 'lucide-react';
export function CertificateSection() {
  return <section className="w-full bg-[#0a0a0a] py-8 md:py-16 px-4" data-id="element-29">
      <div className="max-w-3xl mx-auto" data-id="element-30">
        <div className="flex items-center justify-center gap-3 mb-3" data-id="element-31">
          <AwardIcon className="w-8 h-8 md:w-10 md:h-10 text-[#c41e3a]" aria-hidden="true" data-id="element-32" />
          <p className="text-xs md:text-sm text-[#c41e3a] font-black tracking-widest uppercase" data-id="element-33">
            Al completar la formación
          </p>
        </div>
        <h2 className="text-2xl md:text-4xl font-black text-white text-center mb-3 leading-tight" data-id="element-34">
          Certificado de <span className="text-[#c41e3a]" data-id="element-35">Finalización</span>
        </h2>
        <div className="w-12 h-0.5 bg-[#c41e3a] mx-auto mb-6 md:mb-10" data-id="element-36"></div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 items-center" data-id="element-37">
          {/* Imagen del certificado */}
          <div className="flex justify-center" data-id="element-38">
            <img src="https://cdn.magicpatterns.com/uploads/4HagsNE3J1tEH2k7KUcpQJ/ChatGPT_Image_24_feb_2026,_02_08_32_a.m..png" alt="Certificado de Finalización Método Barber Pro" className="w-36 md:w-48 rounded-lg shadow-xl border-2 border-gray-700" data-id="element-39" />
          </div>

          {/* Descripción */}
          <div className="text-center md:text-left" data-id="element-40">
            <h3 className="text-lg md:text-2xl font-black text-white mb-3 leading-tight" data-id="element-41">
              Acreditá tu formación profesional
            </h3>
            <p className="text-sm md:text-base text-gray-300 leading-relaxed mb-3" data-id="element-42">
              Al completar la formación, recibís un{' '}
              <span className="text-white font-bold" data-id="element-43">
                certificado digital oficial
              </span>{' '}
              que valida tu conocimiento y compromiso con la excelencia en
              barbería.
            </p>
            <p className="text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-44">
              Un respaldo profesional que podés mostrar a tus clientes y usar
              para destacarte en el mercado.
            </p>
          </div>
        </div>
      </div>
    </section>;
}